import {Component, Input} from '@angular/core';
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ApiProvider} from "../../providers/api/api";
import moment from "moment";
import {App, Events, NavController} from "ionic-angular";
import {AppWeightUpdatePage} from "../../pages/app-weight-update/app-weight-update";
import {AppWeightUpdateGoalPage} from "../../pages/app-weight-update-goal/app-weight-update-goal";

/**
 * Generated class for the StatsWeightGraphComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'stats-weight-graph',
  templateUrl: 'stats-weight-graph.html'
})
export class StatsWeightGraphComponent {

  @Input() mode: any;
  weightData: Array<any> = [];
  statsGraph: string = '';
  startEndPoints: Array<any> = [];
  gradients: Array<any> = [];
  lastKnownWeight: number;
  lastKnownWeightId: string;
  lastKnownWeightGoal: string;
  lastKnownWeightGoalId: string;
  lastKnownWeightGoalInitValue: number;
  lastKnownWeightGoalValue: number;

  currentGoalProgressSuffix: string;

  reverseMode: boolean = false;


  constructor(
    private userState: UserStateProvider,
    private api: ApiProvider,
    private app: App,
    private events: Events,
    private navCtrl: NavController
  ) {

    this.buildWeightDataConfig();
    this.events.subscribe('stats:weight:update', () => {
      this.reloadWeightData();
    })
  }

  openWeightUpdate() {
    this.app.getRootNav().push(AppWeightUpdatePage, {currentVal: this.lastKnownWeight});
  }

  openWeightGoal() {
    this.app.getRootNav().push(AppWeightUpdateGoalPage, {currentValue: this.lastKnownWeight});
  }

  ngAfterViewInit() {
    console.log('weightData', this.weightData);

    this.reloadWeightData();
  }

  buildWeightDataConfig(responseData: any = []) {
    console.log('buildWeightConfig', responseData);

    this.weightData = []
    let minWeekInGraph = moment().subtract(6, 'weeks').format('GGGGWW');
    let currentGraphStart = moment().format('GGGGWW');

    for (let dataItem of responseData) {
      if(dataItem.weekId < currentGraphStart) {
        currentGraphStart = dataItem.weekId;
      }
    }

    if(currentGraphStart < minWeekInGraph ){
      currentGraphStart = minWeekInGraph;
    }

    let graphStart = moment(currentGraphStart, 'GGGGWW').subtract(0, 'weeks')
    for(var i = 0; i < 7;i++) {
      this.weightData.push({
        weekId: graphStart.format('GGGGWW'),
        weekLabel: graphStart.format('WW'),
        pos: i
      });
      graphStart.add(1, 'week')
    }
  }

  reloadWeightData() {
    let windowInnerWidth = 500;
    this.api.callGet('/weights').subscribe(response => {
      this.buildWeightDataConfig(response)

      this.lastKnownWeight = null;
      this.lastKnownWeightId = null;

      this.lastKnownWeightGoal = null;
      this.lastKnownWeightGoalId = null;
      this.lastKnownWeightGoalInitValue = null;
      this.lastKnownWeightGoalValue = null;

      let gradientColours = [
        '#fbde6d',
        '#fbde6d',
        '#fbde6d',
        '#fac55a',
        '#f9ad49',
        '#f87f24',
      ]

      this.gradients = [];
      this.startEndPoints = [];
      this.statsGraph = '';

      var weightDataAssoc = [];
      for (let k in this.weightData) {
        weightDataAssoc['W'+this.weightData[k].weekId] = this.weightData[k];
      }

      for(let k in response) {
        var weightDataElem = weightDataAssoc['W'+response[k].weekId];
        if (!weightDataElem) {
          continue;
        }
        weightDataElem.currentValue = response[k].currentValue;
      }

      let filledWeeks = 0;
      for (let w = this.weightData.length -1; w >=0; w--) {
        if(weightDataAssoc['W'+this.weightData[w].weekId].currentValue) {
          filledWeeks++;
        } else {
          break;
        }
      }
      if (filledWeeks >= 4) {
        this.events.publish('stats:weight:filledDataForWeeks', {num: 4});
      }

      let responseData = response;
      console.log(this.weightData);


      for(let k in responseData) {
        if (!this.lastKnownWeightId || this.lastKnownWeightId < response[k].weekId && response[k].currentValue) {
          this.lastKnownWeight = response[k].currentValue;
          this.lastKnownWeightId = response[k].weekId;
        }
        if (!this.lastKnownWeightGoalId || this.lastKnownWeightGoalId < response[k].weekId && response[k].goalComment) {
          this.lastKnownWeightGoal = response[k].goalComment;
          this.lastKnownWeightGoalId = response[k].weekId;
          this.lastKnownWeightGoalInitValue = response[k].goalInitValue;
          this.lastKnownWeightGoalValue = response[k].goalValue;
        }

        var weightDataElem = weightDataAssoc['W'+response[k].weekId];
        if (!weightDataElem) {
          continue;
        }

        var initYValue = response[k].currentValue;
        initYValue = Math.min(initYValue, 135);
        initYValue = Math.max(initYValue, 45);

        let color = gradientColours[Math.round(initYValue/25)];
        let x = (parseInt(weightDataElem.pos))*windowInnerWidth*0.1667+3;
        let y = 214-(parseInt(initYValue))*2.36+107;

        if(x > 497) {
          x = 497;
        }

        // this.startEndPoints.push({x: x, y: y, color: 'red'})
        this.gradients.push({x: Math.round(100*parseInt(weightDataElem.pos)/6), y: color})
        if(!this.statsGraph) {
          this.statsGraph = x+","+y
          this.startEndPoints[0] = {x: x, y: y, color: color}
          this.startEndPoints[1] = {x: x, y: y, color: color}
        } else {
          this.statsGraph += "\n"+x+","+y;
          this.startEndPoints[1] = {x: x, y: y, color: color}
        }
      }


      console.log(this.statsGraph, this.startEndPoints);

      this.currentGoalProgressSuffix = '';
      if(this.lastKnownWeightGoalInitValue && this.lastKnownWeightGoalValue && this.lastKnownWeight) {
        let goalDiff = this.lastKnownWeightGoalValue - this.lastKnownWeightGoalInitValue;
        let currentDiff = this.lastKnownWeightGoalValue - this.lastKnownWeight;
        console.log(currentDiff, goalDiff, (currentDiff / goalDiff));
        if((currentDiff / goalDiff) <= 0) {
          this.currentGoalProgressSuffix = '-finished';
          this.events.publish('stats:weight:goalReached');
        }
        else if((currentDiff / goalDiff) <= 0.5) {
          this.currentGoalProgressSuffix = '-half';
        }
      }
    })
  }

}



// WEBPACK FOOTER //
// ./src/components/stats-weight-graph/stats-weight-graph.ts